/** Refine AccessControlProvider — RBAC через permissions.ts. */

import type { AccessControlProvider } from "@refinedev/core";

import { can } from "@/lib/permissions";
import { useAuthStore } from "@/stores/auth";

export const accessControlProvider: AccessControlProvider = {
  async can({ resource, action }) {
    const role = useAuthStore.getState().user?.role;
    const actionKey = `${resource}:${action}`;
    const allowed = can(role, actionKey);
    return {
      can: allowed,
      reason: allowed ? undefined : `Required permission: ${actionKey}`,
    };
  },
  options: {
    buttons: { enableAccessControl: true, hideIfUnauthorized: true },
  },
};
